/**
 * Hit stop. The harness pipes its rAF delta through `scale` exactly once per
 * frame; everything downstream (scroll, bands, actors, FX, shake decay) then
 * runs on the returned value, so a freeze stops the whole world rather than
 * one subsystem. The freeze budget itself burns down on real time — otherwise
 * a frozen clock could never thaw.
 */
export const FREEZE_CAP_MS = 160;

export class FxTimebase {
  private frozenMs = 0;

  get frozen(): number {
    return this.frozenMs;
  }

  freeze(ms: number): void {
    if (ms <= 0) return;
    this.frozenMs = Math.min(FREEZE_CAP_MS, this.frozenMs + ms);
  }

  /** 0 while frozen, otherwise the delta unchanged. Call once per frame. */
  scale(deltaMs: number): number {
    if (this.frozenMs <= 0) return deltaMs;
    this.frozenMs = Math.max(0, this.frozenMs - deltaMs);
    return 0;
  }

  reset(): void {
    this.frozenMs = 0;
  }
}
